// extracted by mini-css-extract-plugin
export var reviews = "reviews-module--reviews--caed9";
export var reviews__title = "reviews-module--reviews__title--6b633";
export var reviews__video = "reviews-module--reviews__video--9863b";
export var reviews__video_block = "reviews-module--reviews__video_block--68c31";
export var reviews__video_col = "reviews-module--reviews__video_col--ccf00";
export var reviews__video_iframe = "reviews-module--reviews__video_iframe--dfcc8";
export var reviews__video_text = "reviews-module--reviews__video_text--27a9b";
export var reviews__video_wrapper = "reviews-module--reviews__video_wrapper--3c476";
export var student__img = "reviews-module--student__img--806ce";
export var student__prof = "reviews-module--student__prof--8b4d5";
export var student__wrapper = "reviews-module--student__wrapper--3636b";